import ReqClient from './request.class'

// 判断广告组是否有创意
export async function ksCreative(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/creative/hasCreative',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 添加广告组-批量
export async function addCampaignBatch(data) {
  const Req = new ReqClient({
    url: '/api/kuaishou/campaign/batchAdd',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新建快手批量3.0任务
export async function addKuaiShouBatchTask(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/addKuaiShouBatchTask',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取快手原生蓝v服务号
export async function getKuaiShouNativeAuthList(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/nativeAuthList',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取原生快手号列表
export async function getKuaiShouNativeUserList(params) {
  const Req = new ReqClient({
    url: '/api/kuaishou/tools/nativeUserList',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
